import { useState } from 'react';
import {
  Button,
  Stack,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
// hooks
import useAuth from '../../../hooks/useAuth';
// components
import Iconify from '../../../components/Iconify';
import DIOText from '../../../components/DIOText';
import {
  RequestUpdateProfileDialogButton,
} from '../';
import {
  FreeCoffeeChatDialogButton,
  ScoutAddToPoolDialogButton,
  ScoutArchiveDialogButton,
} from '../../scout';
import {
  ScoutCoffeeChatProxyDialog,
} from './'
import {
  CoffeeChatDialogButton,
} from '../';

// ----------------------------------------------------------------------

export default function InstantActionButton({
  profile,
  reload,
  reloadScout,
  coffeeChat,
  openOfferMessage,
  openMeetingConfirmDialog,
  openCheckMeetingSchedule,
  openParttimeOfferDialog,
  openMessagePanel,
}) {
  const { user } = useAuth();
  const [proxyDone, setProxyDone] = useState(false);

  // action 버튼
  const getButtonText = () => {
    if (!coffeeChat) return "";
    if (coffeeChat.coffee_chat_status === "offer-to-company") return "커피챗 미팅 예약하기";
    if (coffeeChat.coffee_chat_status === "meeting-selected") return "커피챗 미팅 링크 확인하기";
    if (coffeeChat.coffee_chat_status === "meeting-confirmed") return "커피챗 미팅 링크 확인하기";
    if (coffeeChat.coffee_chat_status === "meeting-done") return "커피챗 완료";
    return ""
  }

  const buttonAction = () => {
    if (!coffeeChat) return;
    if (coffeeChat.coffee_chat_status === "offer-to-company") openMeetingConfirmDialog();
    if (coffeeChat.coffee_chat_status === "meeting-selected") openCheckMeetingSchedule();
    if (coffeeChat.coffee_chat_status === "meeting-confirmed") openCheckMeetingSchedule();
  }

  // dropdown 버튼
  const getDropdownButtonText = () => {
    if (!coffeeChat) return "";
    if (coffeeChat.coffee_chat_status === "offer-to-crew") return "커피챗 제안 완료";
    if (coffeeChat.coffee_chat_status === "crew-decline") return "크루의 커피챗 거절";
    if (coffeeChat.coffee_chat_status === "other-time-requested") return "크루에게 다른 시간 요청함";
    if (coffeeChat.coffee_chat_status === "company-decline") return "커피챗 거절함";
    return "";
  }

  const getDropdownMenuText = () => {
    if (!coffeeChat) return "";
    return "보낸 커피챗 제안 확인하기";
  }

  const dropdownButtonAction = () => {
    if (!coffeeChat) return;
    openOfferMessage();
  }

  if (!coffeeChat) return <></>;

  const disableActionButton = ["meeting-done"].includes(coffeeChat?.coffee_chat_status);
  const hasPrimaryActionButton = ["offer-to-company", "meeting-selected", "meeting-confirmed", "meeting-done"].includes(coffeeChat?.coffee_chat_status);
  const hasDropdownActionButton = ["offer-to-crew", "other-time-requested", "crew-decline", "company-decline"].includes(coffeeChat?.coffee_chat_status);
  const hasMessageButton = [
    "offer-to-crew", "offer-to-company", "other-time-requested", "meeting-selected", "meeting-confirmed", "meeting-done",
    "crew-decline", "company-decline",
  ].includes(coffeeChat?.coffee_chat_status);
  const hasParttimeOfferButton = ["meeting-done"].includes(coffeeChat?.coffee_chat_status);

  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
  const dropdownMenuOpen = Boolean(dropdownAnchorEl);

  const boldSubButton = ["meeting-done"].includes(coffeeChat?.coffee_chat_status);

  const handleMouseOverDropdown = (event) => {
    setDropdownAnchorEl(event.currentTarget);
  };
  const handleCloseDropdown = () => {
    setDropdownAnchorEl(null);
  };

  const paidPlan = user?.employee?.company?.[0]?.scout_plan === 'enterprise' || user?.employee?.company?.[0]?.scout_plan === 'pro';

  if (!paidPlan && coffeeChat?.coffee_chat_status !== "offer-to-company") {
    return (
      <Stack sx={{ mt: 3 }} spacing={1}>
        <Stack direction="row" spacing={1}>
          <FreeCoffeeChatDialogButton sx={{ mt: 0, width: "none" }} buttonTitle="커피챗 제안하기" />
          <FreeCoffeeChatDialogButton sx={{ mt: 0, width: "none" }} buttonTitle="프로필 작성 요청하기" buttonVariant="outlined" buttonSource="request-profile" />
        </Stack>
        <Typography variant="caption">
          <b>PRO 플랜으로 업그레이드</b> 해보세요!
        </Typography>
      </Stack>
    )
  }

  if (!paidPlan && coffeeChat?.coffee_chat_status === "offer-to-company") {
    return (
      <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
        <FreeCoffeeChatDialogButton sx={{ mt: 0, width: "none" }} buttonTitle="커피챗 미팅 예약하기" buttonSource="coffee-chat" />
        <FreeCoffeeChatDialogButton sx={{ mt: 0, width: "none" }} buttonTitle="메시지 보내기" buttonVariant="outlined" buttonSource="message" />
      </Stack>
    )
  }

  if (paidPlan && coffeeChat?.coffee_chat_status === "evaluable") {
    return (
      <Stack spacing={1.5} sx={{ mt: 3, width: 1 }}>
        <Stack direction="row" spacing={1.5}>
          <ScoutAddToPoolDialogButton profile={profile} selectNextCrew={reload} />
          <ScoutArchiveDialogButton profile={profile} selectNextCrew={reload} />
        </Stack>
        <Typography variant="caption" sx={{ textAlign: "center" }}>
          인재풀에 추가하면, 이 크루에게 커피챗 제안을 보낼 수 있어요.
        </Typography>
      </Stack>
    )
  }

  if (paidPlan && (coffeeChat?.coffee_chat_status === "dio-will-offer" || proxyDone)) {
    return (
      <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
        <Button
          disabled
          variant="contained"
          sx={{ px: 2 }}
        >
          <DIOText />가 제안 예정
        </Button>
      </Stack>
    )
  };

  if (paidPlan && coffeeChat?.coffee_chat_status === "wait" && !proxyDone) {
    return (
      <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
        {/* dropdown button */}
        <Button
          id="coffee-action-dropdown"
          aria-controls={dropdownMenuOpen ? 'coffee-action-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={dropdownMenuOpen ? 'true' : undefined}
          disableElevation
          onClick={handleMouseOverDropdown}
          endIcon={<Iconify icon="ic:chevron-right" sx={{ rotate: "90deg" }}/>}
          sx={{ px: 2 }}
          disableRipple
          variant="contained"
        >
          커피챗 제안하기
        </Button>
        <Menu
          id="coffee-action-menu"
          MenuListProps={{
            'aria-labelledby': 'coffee-action-dropdown',
          }}
          anchorEl={dropdownAnchorEl}
          open={dropdownMenuOpen}
          onClose={handleCloseDropdown}
        >
          <ScoutCoffeeChatProxyDialog profile={profile} reload={reload} proxyDone={() => setProxyDone(true)} />
          <CoffeeChatDialogButton profile={profile} reload={reload} inDropdown={true} />
        </Menu>
        <RequestUpdateProfileDialogButton profile={profile} />
      </Stack>
    )
  }

  if (!paidPlan && coffeeChat?.coffee_chat_status === "wait") {
    return (<></>);
  }

  return (
    <Stack direction="row" spacing={1} sx={{ mt: 3 }}>

      {hasPrimaryActionButton && (
      <Button
        size={"medium"}
        color={"primary"}
        variant={"contained"}
        sx={{ boxShadow: "none", px: 1.5 }}
        onClick={buttonAction}
        disabled={disableActionButton}
      >
        {getButtonText()}
      </Button>
      )}

      {hasDropdownActionButton && (
      <>
        <Button
          id="instant-action-dropdown"
          aria-controls={dropdownMenuOpen ? 'instant-action-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={dropdownMenuOpen ? 'true' : undefined}
          disableElevation
          onClick={handleMouseOverDropdown}
          endIcon={<Iconify icon="ic:chevron-right" sx={{ rotate: "90deg" }}/>}
          sx={{ bgcolor: "grey.300", px: 1.5 }}
          disableRipple
        >
          {getDropdownButtonText()}
        </Button>
        <Menu
          id="instant-action-menu"
          MenuListProps={{
            'aria-labelledby': 'instant-action-dropdown',
          }}
          anchorEl={dropdownAnchorEl}
          open={dropdownMenuOpen}
          onClose={handleCloseDropdown}
        >
          <MenuItem disableRipple sx={{ m: .5, borderRadius: .5 }} onClick={dropdownButtonAction}>
            <Iconify icon={"eva:email-fill"} sx={{ width: 20, height: 20, mr: 2 }} />
            <Typography variant={"subtitle2"}>{getDropdownMenuText()}</Typography>
          </MenuItem>
        </Menu>
      </>
      )}
      {hasMessageButton && (
      <Button
        size={"medium"}
        variant={"outlined"}
        color={"inherit"}
        sx={{
          color: boldSubButton ? "text.primary" : "text.secondary",
          borderColor: (theme) => boldSubButton ? theme.palette.action.active : "#919EAB52",
          px: 1.5
        }}
        onClick={openMessagePanel}
      >
        메시지 보내기
      </Button>
      )}
      {hasParttimeOfferButton && (
      <Button
        size={"medium"}
        variant={"outlined"}
        color={"inherit"}
        sx={{
          color: boldSubButton ? "text.primary" : "text.secondary",
          borderColor: (theme) => boldSubButton ? theme.palette.action.active : "#919EAB52",
          px: 1.5,
        }}
        onClick={openParttimeOfferDialog}
      >
        협업 제안하기
      </Button>
      )}
    </Stack>
  )
}
